import PropTypes from 'prop-types'

import { Icon } from '../display/icon'

const ShareIcon = ({ label = 'Share', ...rest }) => {
  return (
    <Icon
      label={label}
      {...rest}
      dangerouslySetGlyph={`<svg data-name="Layer 1" viewBox="0 0 300 300"><path d="M253.2 139.5a4.9 4.9 0 0 0 .8-2.5 4.6 4.6 0 0 0-.8-2.4l-71.5-74.8a3.7 3.7 0 0 0-3.7-.4 3 3 0 0 0-2 2.9V111c-26.5 0-47.3 1.3-62.2 3.7q-31.6 4.8-48.3 19.1Q46 150 46 180.5a70.2 70.2 0 0 0 10.2 37.4A76.3 76.3 0 0 0 73 238a1.6 1.6 0 0 0 2.6-1.7q-7.8-31.8 2.1-48.5c6.5-10.5 18.8-17.6 37-21.1 13-2.4 33.4-3.7 61.3-3.7v48.8a2.9 2.9 0 0 0 2 2.8 3.5 3.5 0 0 0 3.7-.4z" style="fill:#ff9015"/><path d="M179.6 59.1a4.4 4.4 0 0 1 2.1.7l71.5 74.8a4.6 4.6 0 0 1 .8 2.4 4.9 4.9 0 0 1-.8 2.5l-71.5 74.7a3.7 3.7 0 0 1-2.1.8 5.3 5.3 0 0 1-1.6-.4 2.9 2.9 0 0 1-2-2.8V163c-27.9 0-48.3 1.3-61.3 3.7-18.2 3.5-30.5 10.6-37 21.1s-7.3 27.3-2.1 48.5a1.6 1.6 0 0 1-1.5 2.1 2.1 2.1 0 0 1-1.1-.4 76.3 76.3 0 0 1-16.8-20.1A70.2 70.2 0 0 1 46 180.5q0-30.5 19.5-46.7 16.6-14.3 48.3-19.1c14.9-2.4 35.7-3.7 62.2-3.7V62.3a3 3 0 0 1 2-2.9l1.6-.3m0-10a14 14 0 0 0-5.3 1.1 12.9 12.9 0 0 0-8.3 12.1v38.8c-22.3.3-40.3 1.5-53.7 3.7-22.9 3.5-40.8 10.7-53.2 21.3C43.8 138.9 36 157.2 36 180.5A80.2 80.2 0 0 0 47.6 223a85.4 85.4 0 0 0 19 22.6 11.4 11.4 0 0 0 7.5 2.8A11.8 11.8 0 0 0 85.4 234c-4.6-18.5-4.3-32.3.9-41s15.1-13.5 30.2-16.5c10.8-2 27.4-3.1 49.5-3.4v38.7a12.9 12.9 0 0 0 8.3 12.1 14 14 0 0 0 5.3 1.1 13.5 13.5 0 0 0 8.1-2.8l.6-.5.6-.6 71.5-74.7.6-.6.5-.8a13.9 13.9 0 0 0 0-15.9l-.5-.8-.6-.6-71.5-74.8-.6-.6-.6-.5a14.1 14.1 0 0 0-8.1-2.7z" style="fill:#1d1d1b"/></svg>`}
    />
  )
}

ShareIcon.propTypes = {
  onClick: PropTypes.func,
  label: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.oneOf(['tiny', 'small', 'medium', 'large'])
}

export { ShareIcon }
